<template>
  <div>
    <CRow>
      <CCol sm="6">
        <div class="card-title mb-3">
          {{ $t("role.planning.island.title") }}
        </div>
      </CCol>
      <CCol sm="6" class="justify-content-end d-flex">
        <div>
          <CButton color="primary" class="mb-3" @click="addIsland()">
            <font-awesome-icon icon="plus" class="mr-2" />
            {{ $t("role.planning.island.addIsland") }}
          </CButton>
        </div>
      </CCol>
    </CRow>

    <CRow v-if="islandData && islandData.length > 0" class="p-3">
      <Header
        :data="[
          $t('models.mpi.island'),
          $t('models.mpi.price'),
          $t('models.mpi.order_offset'),
          $t('models.logistics.connections.country'),
          $t('models.logistics.connections.phone'),
          'URL',
          $t('models.logistics.connections.contacts'),
          $t('models.logistics.connections.serviceZone'),
          'Actions',
        ]"
      />
      <Row
        v-for="(item, index) in islandData"
        :key="index"
        :data="[
          {
            data: islandName(item.island.role.name, item.island.role.id),
            type: 'html',
          },
          { data: item.price, type: 'text' },
          { data: item.offset, type: 'text' },
          { data: item.island.role.country, type: 'text' },
          { data: item.island.role.tel, type: 'text' },
          { data: item.island.role.url, type: 'text' },
          { data: item.island.role.info_contact, type: 'text' },
          { data: item.island.role.desc_zone, type: 'text' },
          { data: '', type: 'actions' },
        ]"
        :border="true"
        :topAligned="true"
      >
        <template #actions>
          <div class="d-flex justify-content-end">
            <CButton
              class="mr-2 mt-2"
              size="sm"
              color="primary"
              @click="editIsland(item)"
            >
              <font-awesome-icon icon="edit" />
            </CButton>
            <CButton
              class="mr-2 mt-2"
              size="sm"
              color="primary"
              @click="showDeleteConfirmation(item.id)"
            >
              <font-awesome-icon icon="trash-alt" />
            </CButton>
          </div>
        </template>
      </Row>
    </CRow>

    <IslandModal
      :show.sync="modal.show"
      :title="modal.title"
      :values="modal.values"
      :edit-mode="modal.editMode"
      :edit-id="modal.editId"
      @submitted="fetchData"
    />

    <CModal
      :title="$t('role.planning.closing_days.modal.title')"
      :show.sync="deleteModal.show"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <p>
        {{ $t("role.planning.closing_days.modal.subtitle") }}
      </p>
      <p>
        {{ $t("role.planning.closing_days.modal.text") }}
      </p>
      <template #footer>
        <CButton color="primary" @click="onModalConfirm">{{
          $t("common.editor.button.confirm")
        }}</CButton>
        <CButton color="primary" variant="outline" @click="onModalClose">{{
          $t("common.editor.button.cancel")
        }}</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import Row from "../../../common/table/Row.vue";
import Header from "../../../common/table/Header.vue";
import IslandModal from "./IslandModal.vue";
import { apiGet, apiDelete } from "../../../helpers/apiHelper";

export default {
  components: {
    Row,
    Header,
    IslandModal,
  },
  data() {
    return {
      islandData: [],
      modal: {
        show: false,
        title: "",
        values: {},
        editMode: false,
        editId: null,
      },
      deleteModal: {
        show: false,
        islandIdToDelete: null,
      },
    };
  },

  methods: {
    islandName(name, id) {
      return name ? `<strong>${name}</strong><br>I-${id}` : "";
    },

    addIsland() {
      this.modal.title = this.$t("role.planning.island.addIsland");
      this.modal.values = {};
      this.modal.editMode = false;
      this.modal.editId = null;
      this.modal.show = true;
    },

    editIsland(item) {
      this.modal.title = this.$t("role.planning.island.editIsland");
      this.modal.values = item;
      this.modal.editMode = true;
      this.modal.editId = item.id;
      this.modal.show = true;
    },

    async removeIsland(id) {
      const response = await apiDelete("role_marketisland_connections", id, [
        this.$store.state.role.id,
      ]);
      if (response && response.status === 204) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.planning.producer.removedMsg"),
          color: "success",
          autohide: true,
        });
        await this.fetchData();
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error removing distributor",
          color: "danger",
          autohide: true,
        });
      }
    },

    showDeleteConfirmation(id) {
      this.deleteModal.islandIdToDelete = id;
      this.deleteModal.show = true;
    },

    onModalConfirm() {
      this.deleteModal.show = false;
      this.removeIsland(this.deleteModal.islandIdToDelete);
    },

    onModalClose() {
      this.deleteModal.show = false;
      this.deleteModal.islandIdToDelete = null;
    },

    async fetchData() {
      const response = await apiGet(
        "role_marketisland_connections",
        [this.$store.state.role.id],
        null
      );
      if (response && response.status === 200) {
        this.islandData = response.data.Items.sort(
          (a, b) => a.island.id - b.island.id
        );
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading planning data",
          color: "danger",
          autohide: true,
        });
      }
    },
  },

  async created() {
    await this.fetchData();
  },
};
</script>
